<template>
  <div
    class="gallery-actions__actions-container container container--no-padding print-hidden"
    :class="[
      isMultipleGallery
        ? 'multiple-image-gallery-container'
        : 'single-image-gallery-container ',
    ]"
  >
    <ShareAdForm
      :ad-id="adId"
      :name="name"
      :ad-variant-info="adVariantInfo"
      :recaptcha-sitekey="recaptchaSitekey"
      ref="shareAdForm"
    ></ShareAdForm>
    <div
      class="gallery-actions__actions-panel"
      :class="[
        isMultipleGallery ? 'multiple-image-gallery' : 'single-image-gallery',
      ]"
    >
      <button
        type="button"
        class="button gallery-actions__actions-panel--share-button"
        @click.prevent="shareClicked()"
      >
        <img
          loading="lazy"
          class="gallery-actions__actions-panel--icon"
          src="../../assets/icons/share-green.svg"
          alt="Del"
        />
      </button>
      <button
        type="button"
        class="button gallery-actions__actions-panel--print-button"
        @click="printDocument()"
      >
        <img
          loading="lazy"
          class="gallery-actions__actions-panel--icon"
          src="../../assets/icons/print-green.svg"
          alt="Print"
        />
      </button>
      <button
        type="button"
        class="button"
        :class="[
          isFavorized
            ? 'gallery-actions__actions-panel--favorite-button-filled'
            : 'gallery-actions__actions-panel--favorite-button',
        ]"
        @click="toggleFavorite()"
      >
        <img
          v-if="!isFavorized"
          loading="lazy"
          class="gallery-actions__actions-panel--icon"
          src="../../assets/icons/star-green-outline.svg"
          alt="Print"
        />
        <img
          v-if="isFavorized"
          loading="lazy"
          class="gallery-actions__actions-panel--icon"
          src="../../assets/icons/star-green-filled.svg"
          alt="Favorit"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { app } from '@/main'

import { handleToggle } from '@components/Ad/AdFavoriteHandlerFunction'
import ShareAdForm from '@components/ShareAdForm/ShareAdForm.vue'

export default {
  components: {
    ShareAdForm,
  },
  props: {
    isFavorite: { default: false, type: Boolean },
    adId: { default: 0, type: Number },
    name: { default: '', type: String },
    adVariantInfo: { default: null, type: Object },
    isMultipleGallery: { default: false, type: Boolean },
    recaptchaSitekey: { default: '', type: String },
  },
  data() {
    return {
      isFavorized: false,
    }
  },
  methods: {
    shareClicked() {
      this.$refs.shareAdForm.openForm()
    },
    printDocument() {
      window.print()
    },
    toggleFavorite() {
      const toBeFavorized = !this.isFavorized

      handleToggle(this.adId, toBeFavorized)
    },
    handleFavoriteAddedCallback(adId) {
      if (adId !== this.adId) return
      this.isFavorized = true
    },
    handleFavoriteRemovedCallback(adId) {
      if (adId !== this.adId) return
      this.isFavorized = false
    },
    checkIfFavorite(favorites) {
      if (favorites.includes(this.adId)) {
        this.isFavorized = true
      }
    },
  },
  mounted() {
    this.isFavorized = this.isFavorite

    app.mitt.on('favorite-added', this.handleFavoriteAddedCallback)

    app.mitt.on('favorite-removed', this.handleFavoriteRemovedCallback)

    app.mitt.on('login-complete', this.checkIfFavorite)
  },
}
</script>

<style lang="scss">
@import 'GalleryActions.scss';
</style>
